import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { googleLogin } from "../../api/auth";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Google from "../../helper/svg/Google.svg";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const CustomGoogleButton = () => {
  const navigate = useNavigate();
  const { storeDataToStorage } = useAuth();

  const loginMutation = useMutation({
    mutationFn: googleLogin,
    onSuccess: ({ data }) => {
      const { token, user } = data;
      toast.success("Login successful!");
      storeDataToStorage(user, token);

      if (user.role === "admin") navigate("/admindashboard");
      else if (user.role === "user") navigate("/");
      else if (user.role === "owner") navigate("/ownerdashboard");
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message || "Invalid email or password.";
      toast.error(errorMessage);
    },
  });

  const login = useGoogleLogin({
    onSuccess: (response) => {
  
      // you’ll get access_token here
      loginMutation.mutate({ token: response.access_token });
    },
    onError: () => toast.error("Google login failed!"),
  });

  // <Link
  //             className="text-[#FFA808] flex items-center justify-center gap-[16px] w-full text-center text-[#333333] md:text-[20px] text-[16px] font-medium border border-[#333333] p-[20px] rounded-[10px] mt-[18px] hover:border-[#4CAF50]"
  //             to="/"
  //           >
  //             <img src={Google} alt="google" className="w-[20px]" />
  //             Continue with Google
  //           </Link>

  return (
    <button
      onClick={() => login()}
      className="text-[#FFA808] flex items-center justify-center gap-[16px] w-full text-center text-[#333333] md:text-[20px] text-[16px] font-medium border border-[#333333] p-[20px] rounded-[10px] mt-[18px] hover:border-[#4CAF50]"
    >
      <img src={Google} alt="Google" className="w-[20px]" />
      <span>Sign in with Google</span> 
    </button>
  );
};

export const LoginWithGoogle = () => {
  if (!GOOGLE_CLIENT_ID) {
    return (
      <button
        disabled
        className="text-[#FFA808] flex items-center justify-center gap-[16px] w-full text-center text-[#333333] md:text-[20px] text-[16px] font-medium border border-[#333333] p-[20px] rounded-[10px] mt-[18px] opacity-50 cursor-not-allowed"
      >
        <img src={Google} alt="Google" className="w-[20px]" />
        <span>Sign in with Google (Not Available)</span>
      </button>
    );
  }
  
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <CustomGoogleButton />
    </GoogleOAuthProvider>
  );
};
